import { Types } from "@grandvisionhq/graphql";
const ReturnStatus = Types.ReturnStatus;
export {
  ReturnStatus
};
//# sourceMappingURL=returns.js.map
